import { action , observable, runInAction} from "mobx";

declare type NotificationType = "success" | "error" | "info" | "warning";

export class NotificationStore {

    @observable 
    public delay: number = 0;

    @observable
    public text!: string;

    @observable
    public visible!: boolean;

    @observable
    public timeout: number | null = 5000;

    @observable
    public type!: NotificationType;

    @action
    public showToast = (text: string, type: NotificationType, timeout: number = 5000): number=> {

        return this.delayToast(text, type, 0, timeout);
    }

    @action
    public delayToast = (text: string, type: NotificationType, delay: number = 0, timeout?: number | null, onTostShow?: () => void): number => {
        this.text = `${text} | SHL`;
        this.type = type;
        this.delay = 0;
        this.timeout = timeout ? timeout : 5000;

        return window.setTimeout(() => {
            runInAction(() => this.visible = true)
            if (onTostShow) {
                onTostShow();
            }
        }, delay);
    }

    @action
    public cancel = (handler: number) => {
        window.clearTimeout(handler);
    }

    @action
    public closeToast = () => {
        this.visible = false;
    }
}

export default new NotificationStore();